import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
//import CircleIcon from '../Common/CircleIcon'
//import Input from '../Common/Input'
import Svgs from '../Common/Svgs';
import 'react-phone-number-input/style.css';
import Button from '../Common/Button';
//import Profile from '../Profile'
//import WebcamVideoR from '../WebcamVideoR'
import { useLongPress, LongPressDetectEvents } from 'use-long-press';

import { useReactMediaRecorder } from 'react-media-recorder';
import VideoModal from './VideoModal';

const Seven = (props) => {
  const onTextAreaChange = (param) => {
    props.setState({ ...props.State, suggestions: param.target.value });
  };
  const [Type, setType] = useState(null); // audio, video
  const [showModal, setShowModal] = React.useState(false);

  const [videoState, setVideoState] = useState(''); // cancel, save

  const {
    status,
    startRecording,
    stopRecording,
    pauseRecording,
    mediaBlobUrl,
    previewStream,
  } = useReactMediaRecorder({
    video: Type === 'video' ? true : false,
    audio: ['audio', 'video'].includes(Type) ? true : false,
    echoCancellation: true,
  });
  const handleChange = (param) => {
    props.setActive(props.Active + 1);
  };
  const [Text, setText] = useState([]);

  useEffect(() => {
    setText(props.Language);
  }, [props.Language]);

  const [enabled, setEnabled] = React.useState(true);
  const callback = React.useCallback(() => {}, []);
  const bind = useLongPress(enabled ? callback : null, {
    onStart: (event, meta) => {
      startRecording();
    },
    onFinish: (event, meta) => {
      stopRecording();
    },
    onCancel: (event, meta) => console.log('Press cancelled', meta),
    filterEvents: (event) => true, // All events can potentially trigger long press
    threshold: 500,
    captureEvent: true,
    cancelOnMovement: false,
    detect: LongPressDetectEvents.BOTH,
  });

  const setVideo = () => {
    props.setState({ ...props.State, video: mediaBlobUrl });
  };

  useEffect(() => {
    if (!Type) return;

    if (Type === 'audio') {
      props.setState((prev) => ({ ...prev, audio: mediaBlobUrl }));
    }
    if (Type === 'video' && videoState === 'save') {
      props.setState((prev) => ({ ...prev, video: mediaBlobUrl }));
    }
  }, [mediaBlobUrl, Type]);

  return (
    <>
      <div className='slide-in-right  flex flex-col gap-6 items-center'>
        <h1
          className={`text-3xl font-extrabold ${Text?.lang == 'UR' && 'urdu'}`}
        >
          {Text.text}
        </h1>
        <div className='flex flex-col items-center gap-5'>
          <div className='p-4 bg-white rounded-lg relative pb-[3rem]'>
            <textarea
              className='resize-none outline-none text-[#555555]'
              onChange={onTextAreaChange}
              cols='30'
              rows='6'
              placeholder='Write Something Here...'
            ></textarea>
            <div className='absolute bottom-2 right-2 flex items-center gap-3'>
              <div
                className='cursor-pointer'
                onClick={() => {
                  //   startRecording();
                  setType('video');
                  setShowModal(true);
                }}
              >
                <Svgs.Camera />
              </div>

              <div className='cursor-pointer' onClick={() => setType('audio')}>
                <Svgs.Mic />
              </div>
            </div>
          </div>
          <Button onClick={handleChange} text='Next' />
        </div>
        <div>
          {Type === 'audio' && (
            <button {...bind('')} type='button' className=' h-15 w-50 p-5 btn'>
              Hold To Record
            </button>
          )}
          {props.State.audio && <video src={props.State.audio} controls loop />}
          {props.State.video && <video src={props.State.video} controls loop />}
        </div>
      </div>

      {showModal && (
        <VideoModal
          {...{
            startRecording,
            stopRecording,
            setShowModal,
            previewStream,
            setVideoState
          }}
        />
      )}
    </>
  );
};

export default Seven;
